import { useEffect } from "react";
import { useQueries } from "react-query";
import { getGraphTypeKey } from "shared/helpers/helpers";
import { getGraphService } from "shared/services";
import { graphQueryKey } from "shared/hooks/useRealtimeGraphData";


export const useGetGraphQueries = (location, machine, swtName) => {
    const graphTypes = swtName === 'TGS'
        ? ['gas_graph', 'gas_enclosure_graph', 'outside_graph', 'gas_snow_graph', 'gas_wind_graph']
        : ['heater_graph', 'enclosure_graph', 'outside_graph', 'snow_graph', 'wind_graph'];

    const queries = useQueries(
        graphTypes.map((graphType) => ({
            queryKey: graphQueryKey(machine, getGraphTypeKey(graphType)),
            queryFn: async () => (await getGraphService(machine, graphType))?.graph ?? [],
            onError: (error) => {
                console.error('get graph fail:', error.message);
            },
            staleTime: Infinity,
        }))
    );

    useEffect(() => {
        return () => {
            queries.forEach((query) => query.remove());
        };
    }, []);

    return queries;
}
